import { Gestor } from "./gestor.model";

export class AssistenteDTO {
    constructor(
        public login?: string,   
        public nome?: string, 
        public cpf?: string,
        public senha?: string,
        public gestor?: Gestor,
    ) { 
    }
}